// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.easycommerce-help-search-input {
    border: none !important;
    padding-right: 100px !important;
    padding-left: 43px !important;
    border-radius: 12px !important;
}
.easycommerce-help-search-input:focus {
    box-shadow: none !important;
}
.easycommerce-modal-form input,
.easycommerce-modal-form textarea,
.easycommerce-modal-form select {
    border-radius: 6px !important;
    padding: 11px !important;
    border: 1px solid #dbdbdb !important;
}
.easycommerce-modal-form input:focus,
.easycommerce-modal-form textarea:focus,
.easycommerce-modal-form select:focus {
    box-shadow: none !important;
}
.easycommerce-modal-form select {
    max-width: 100% !important;
    width: 100% !important;
    color: var(--color-ec-secondary) !important;
    font-size: 16px;
}
.easycommerce-addon-search-input {
    border: none !important;
    padding: 15px !important;
    border-top: 2px solid var(--color-ec-border) !important;
    border-bottom: 2px solid var(--color-ec-border) !important;
    border-radius: 0 !important;
}
.easycommerce-addon-search-input:focus {
    outline: 0 !important;
    box-shadow: none !important;
}

/* Post content */
.easycommerce-doc-content-wrap p {
    font-size: 16px;
    font-family: "Inter", sans-serif;
    margin-bottom: 24px;
    line-height: 26px;
    color: var(--color-ec-body);
    font-weight: 400;
}
.easycommerce-doc-content-wrap blockquote {
    font-size: 15px;
    font-style: italic;
    font-family: "Inter", sans-serif;
    line-height: 26px;
    color: var(--color-ec-body);
    font-weight: 400;
    padding: 15px;
    background-color: #e9e9e9;
    border-radius: 6px;
    margin-bottom: 24px;
}
.easycommerce-doc-content-wrap h1,
.easycommerce-doc-content-wrap h2,
.easycommerce-doc-content-wrap h3,
.easycommerce-doc-content-wrap h4,
.easycommerce-doc-content-wrap h5,
.easycommerce-doc-content-wrap h6 {
    color: var(--color-ec-body);
    margin-bottom: 24px;
}
.easycommerce-doc-content-wrap h1 {
    font-size: 30px;
}
.easycommerce-doc-content-wrap h2 {
    font-size: 28px;
}
.easycommerce-doc-content-wrap h3 {
    font-size: 26px;
}
.easycommerce-doc-content-wrap h4 {
    font-size: 24px;
}
.easycommerce-doc-content-wrap h5 {
    font-size: 22px;
}
.easycommerce-doc-content-wrap h6 {
    font-size: 20px;
}

.easycommerce-doc-content-wrap ul,
.easycommerce-doc-content-wrap ol {
    margin-bottom: 32px;
}
.easycommerce-doc-content-wrap ol {
    list-style-type: decimal;
    margin-left: 20px;
}
.easycommerce-doc-content-wrap ul {
    list-style-type: disc;
    margin-left: 20px;
}
.easycommerce-doc-content-wrap ul li,
.easycommerce-doc-content-wrap ol li {
    font-size: 16px;
    font-family: "Inter", sans-serif;
    margin-bottom: 16px;
    line-height: 26px;
    color: var(--color-ec-body);
    font-weight: 400;
}
.easycommerce-doc-content-wrap img {
    margin-bottom: 24px;
    margin-left: auto;
    margin-right: auto;
}
.easycommerce-doc-content-wrap b,
.easycommerce-doc-content-wrap strong {
    font-weight: 700;
}
`, "",{"version":3,"sources":["webpack://./spa/admin/easycommerce/src/css/main-menu.css"],"names":[],"mappings":"AAAA;IACI,uBAAuB;IACvB,+BAA+B;IAC/B,6BAA6B;IAC7B,8BAA8B;AAClC;AACA;IACI,2BAA2B;AAC/B;AACA;;;IAGI,6BAA6B;IAC7B,wBAAwB;IACxB,oCAAoC;AACxC;AACA;;;IAGI,2BAA2B;AAC/B;AACA;IACI,0BAA0B;IAC1B,sBAAsB;IACtB,2CAA2C;IAC3C,eAAe;AACnB;AACA;IACI,uBAAuB;IACvB,wBAAwB;IACxB,uDAAuD;IACvD,0DAA0D;IAC1D,2BAA2B;AAC/B;AACA;IACI,qBAAqB;IACrB,2BAA2B;AAC/B;;AAEA,iBAAiB;AACjB;IACI,eAAe;IACf,gCAAgC;IAChC,mBAAmB;IACnB,iBAAiB;IACjB,2BAA2B;IAC3B,gBAAgB;AACpB;AACA;IACI,eAAe;IACf,kBAAkB;IAClB,gCAAgC;IAChC,iBAAiB;IACjB,2BAA2B;IAC3B,gBAAgB;IAChB,aAAa;IACb,yBAAyB;IACzB,kBAAkB;IAClB,mBAAmB;AACvB;AACA;;;;;;IAMI,2BAA2B;IAC3B,mBAAmB;AACvB;AACA;IACI,eAAe;AACnB;AACA;IACI,eAAe;AACnB;AACA;IACI,eAAe;AACnB;AACA;IACI,eAAe;AACnB;AACA;IACI,eAAe;AACnB;AACA;IACI,eAAe;AACnB;;AAEA;;IAEI,mBAAmB;AACvB;AACA;IACI,wBAAwB;IACxB,iBAAiB;AACrB;AACA;IACI,qBAAqB;IACrB,iBAAiB;AACrB;AACA;;IAEI,eAAe;IACf,gCAAgC;IAChC,mBAAmB;IACnB,iBAAiB;IACjB,2BAA2B;IAC3B,gBAAgB;AACpB;AACA;IACI,mBAAmB;IACnB,iBAAiB;IACjB,kBAAkB;AACtB;AACA;;IAEI,gBAAgB;AACpB","sourcesContent":[".easycommerce-help-search-input {\n    border: none !important;\n    padding-right: 100px !important;\n    padding-left: 43px !important;\n    border-radius: 12px !important;\n}\n.easycommerce-help-search-input:focus {\n    box-shadow: none !important;\n}\n.easycommerce-modal-form input,\n.easycommerce-modal-form textarea,\n.easycommerce-modal-form select {\n    border-radius: 6px !important;\n    padding: 11px !important;\n    border: 1px solid #dbdbdb !important;\n}\n.easycommerce-modal-form input:focus,\n.easycommerce-modal-form textarea:focus,\n.easycommerce-modal-form select:focus {\n    box-shadow: none !important;\n}\n.easycommerce-modal-form select {\n    max-width: 100% !important;\n    width: 100% !important;\n    color: var(--color-ec-secondary) !important;\n    font-size: 16px;\n}\n.easycommerce-addon-search-input {\n    border: none !important;\n    padding: 15px !important;\n    border-top: 2px solid var(--color-ec-border) !important;\n    border-bottom: 2px solid var(--color-ec-border) !important;\n    border-radius: 0 !important;\n}\n.easycommerce-addon-search-input:focus {\n    outline: 0 !important;\n    box-shadow: none !important;\n}\n\n/* Post content */\n.easycommerce-doc-content-wrap p {\n    font-size: 16px;\n    font-family: \"Inter\", sans-serif;\n    margin-bottom: 24px;\n    line-height: 26px;\n    color: var(--color-ec-body);\n    font-weight: 400;\n}\n.easycommerce-doc-content-wrap blockquote {\n    font-size: 15px;\n    font-style: italic;\n    font-family: \"Inter\", sans-serif;\n    line-height: 26px;\n    color: var(--color-ec-body);\n    font-weight: 400;\n    padding: 15px;\n    background-color: #e9e9e9;\n    border-radius: 6px;\n    margin-bottom: 24px;\n}\n.easycommerce-doc-content-wrap h1,\n.easycommerce-doc-content-wrap h2,\n.easycommerce-doc-content-wrap h3,\n.easycommerce-doc-content-wrap h4,\n.easycommerce-doc-content-wrap h5,\n.easycommerce-doc-content-wrap h6 {\n    color: var(--color-ec-body);\n    margin-bottom: 24px;\n}\n.easycommerce-doc-content-wrap h1 {\n    font-size: 30px;\n}\n.easycommerce-doc-content-wrap h2 {\n    font-size: 28px;\n}\n.easycommerce-doc-content-wrap h3 {\n    font-size: 26px;\n}\n.easycommerce-doc-content-wrap h4 {\n    font-size: 24px;\n}\n.easycommerce-doc-content-wrap h5 {\n    font-size: 22px;\n}\n.easycommerce-doc-content-wrap h6 {\n    font-size: 20px;\n}\n\n.easycommerce-doc-content-wrap ul,\n.easycommerce-doc-content-wrap ol {\n    margin-bottom: 32px;\n}\n.easycommerce-doc-content-wrap ol {\n    list-style-type: decimal;\n    margin-left: 20px;\n}\n.easycommerce-doc-content-wrap ul {\n    list-style-type: disc;\n    margin-left: 20px;\n}\n.easycommerce-doc-content-wrap ul li,\n.easycommerce-doc-content-wrap ol li {\n    font-size: 16px;\n    font-family: \"Inter\", sans-serif;\n    margin-bottom: 16px;\n    line-height: 26px;\n    color: var(--color-ec-body);\n    font-weight: 400;\n}\n.easycommerce-doc-content-wrap img {\n    margin-bottom: 24px;\n    margin-left: auto;\n    margin-right: auto;\n}\n.easycommerce-doc-content-wrap b,\n.easycommerce-doc-content-wrap strong {\n    font-weight: 700;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
